/* eslint-disable */
define(
  'modules/feature-view',
  [
    'jquery',
    'vendor/slick',
    'modules/utils',
    'modules/animation',
    'modules/tracking'
  ],
  function (
    $,
    slick,
    M_Utils,
    M_Animation,
    M_Tracking
  ) {
    'use strict';

    var selectors = {
      container: '.js-feature-container',
      closeButton: '.js-feature-close',
      media: '.js-feature-media',
      nav: '.js-feature-nav-list',
      navItem: '.js-feature-nav-item',
      navControls: '.js-feature-nav-controls',
      navPrev: '.js-feature-nav-prev',
      navNext: '.js-feature-nav-next',
      navSlide: '.slick-slide',
      caption: '.js-feature-caption',
      heading: '.js-feature-heading',
      copy: '.js-feature-copy',
      cta1: '.js-feature-cta-1',
      cta2: '.js-feature-cta-2',
      cta1Text: '.js-feature-cta-1-text',
      cta2Text: '.js-feature-cta-2-text',
      ctas: '.c-nx-feature__cta'
    };
    var classes = {
      containerBase: 'c-nx-feature',
      containerJS: 'js-feature-container',
      navItem: 'js-feature-nav-item',
      isActive: 'is--active',
      isVisible: 'is--visible'
    };
    var htmlTemplates = {
      navItem: '<li class="c-nx-feature__nav-item {{class}}" data-view="{{view}}"><img src="{{src}}" class="c-nx-feature__nav-item-image"></li>',
      mediaVideo: '<video class="c-nx-feature__media-video" src="{{src}}" muted loop playsinline autoplay></video>',
      mediaPictureOpening: '<picture class="c-nx-feature__media-image">',
      mediaPictureClosing: '</picture>',
      mediaPictureSourceDefault: '<img src="{{src}}" />',
      mediaPictureSourceDesktop: '<source srcset="{{src}}" media="(min-width: 992px)">'
    };
    var variants = {
      feature: 'feature',
      story: 'story'
    };
    var state = {
      isOpen: false,
      currentView: null,
      prevView: null,
      nextView: null,
      currentVariant: null,
      prevVariant: null,
      previousCarView: '',
      isNavigating: false,
      isPortrait: true
    };
    var numThumbnailsToShow = 5;
    var carViews;
    var content;
    var $container
      , $closeButton
      , $media
      , $nav
      , $navControls
      , $navPrev
      , $navNext
      , $caption
      , $heading
      , $copy
      , $cta1
      , $cta2
      , $cta1Text
      , $cta2Text
      , $ctas;
    var attributes = {
      trackingLabel: 'data-tracking-label'
    };

    function init (config) {
      content = config.manifest.featureViews;
      carViews = M_Utils.getCarViews();
      getElems();
      state.isPortrait = M_Utils.getIsPortrait();
    }

    function getElems () {
      $container = $(selectors.container);
      $closeButton = $(selectors.closeButton);
      $media = $(selectors.media);
      $nav = $(selectors.nav);
      $navControls = $(selectors.navControls);
      $navPrev = $(selectors.navPrev);
      $navNext = $(selectors.navNext);
      $caption = $container.find(selectors.caption);
      $heading = $container.find(selectors.heading);
      $copy = $container.find(selectors.copy);
      $cta1 = $container.find(selectors.cta1);
      $cta2 = $container.find(selectors.cta2);
      $cta1Text = $container.find(selectors.cta1Text);
      $cta2Text = $container.find(selectors.cta2Text);
      $ctas = $container.find(selectors.ctas);
    }

    function bindEvents () {
      $closeButton.off('click').on('click', onCloseButtonClick);
      $nav.find(selectors.navItem).off('click').on('click', onNavItemClick);
      $navPrev.off('click').on('click', onNavControlPrevClick);
      $navNext.off('click').on('click', onNavControlNextClick);
      $ctas.off('click').on('click', onCtaLinkClick);
      M_Utils.bindOrientationChange(onOrientationChange);
    }

    function displayMediaForView (view, onMediaLoaded) {
      M_Animation.playSequence('featureMediaFadeOut', function () {
        populateMedia(content[view], function () {
          M_Animation.playSequence('featureMediaFadeIn');

          if (typeof onMediaLoaded === 'function') {
            onMediaLoaded();
          }
        });
      });
    }

    function displayView (view) {
      M_Tracking.trackEvent('access-hotspot', view);

      if (!content.hasOwnProperty(view)) {
        return;
      }

      if (!isValidVariant(content[view].variant)) {
        return;
      }

      state.isNavigating = true;

      showNavControls(false);
      updateState(view);
      updateContainerClass();
      
      if (state.isOpen) {
        M_Animation.playSequence('featureFadeOut', function () {
          populateAndDisplayView(view, true);
        });
      } else {
        M_Animation.playSequence('featureOpen', function () {
          populateAndDisplayView(view, false);
        });
      }
    }

    function populateAndDisplayView (view, wasAlreadyOpen) {
      populateContent(view, wasAlreadyOpen);
      bindEvents();

      state.isOpen = true;

      M_Animation.playSequence('featureFadeIn', function () {
        state.isNavigating = false;
        showNavControls(true);
      });
    }

    function updateState (view) {
      var contentKeys = Object.keys(content).filter(function (key) {
        return viewVariantsMatch(key, view) && viewIsForCurrentCarView(key, M_Utils.getSelectedView());
      });

      var isRTL = M_Utils.getIsRTL();

      if (isRTL) {
        contentKeys.reverse();
      }

      var currentItemIndex = contentKeys.indexOf(view);

      var prevViewIndex = currentItemIndex - 1;

      if (prevViewIndex < 0) {
        prevViewIndex = contentKeys.length + prevViewIndex;
      }

      var nextViewIndex = currentItemIndex + 1;

      if (nextViewIndex >= contentKeys.length) {
        nextViewIndex = nextViewIndex - contentKeys.length;
      }

      state.currentView = view;
      state.prevView = isRTL ? contentKeys[nextViewIndex] : contentKeys[prevViewIndex];
      state.nextView = isRTL ? contentKeys[prevViewIndex] : contentKeys[nextViewIndex];
      state.prevVariant = state.currentVariant;
      state.currentVariant = content[view].variant;
    }

    function populateContent (view, wasAlreadyOpen) {
      populateCopy(content[view]);
      populateNav(view, wasAlreadyOpen);
    }

    function populateCopy (viewContent) {
      $caption.text(viewContent.caption);
      $heading.text(viewContent.heading);
      $copy.text(viewContent.copy);
      $cta1Text.text(viewContent.cta1.copy);
      $cta2Text.text(viewContent.cta2.copy);
      $cta1.attr('href', viewContent.cta1.url);
      $cta2.attr('href', viewContent.cta2.url);
    }

    function populateMedia (viewContent, onMediaLoaded) {
      $media.empty();

      if (!viewContent.media) {
        return;
      }

      var mediaInnerHtml = '';

      if (viewContent.media.hasOwnProperty('video')) {
        mediaInnerHtml = M_Utils.populateTemplateString(htmlTemplates.mediaVideo, [
          ['{{src}}', viewContent.media.video]
        ]);
      }
      else if (viewContent.media.hasOwnProperty('default')) {
        mediaInnerHtml += htmlTemplates.mediaPictureOpening;

        if (viewContent.media.hasOwnProperty('desktop')) {
          mediaInnerHtml += M_Utils.populateTemplateString(htmlTemplates.mediaPictureSourceDesktop, [
                          ['{{src}}', viewContent.media.desktop]
                        ]);
        }

        mediaInnerHtml += M_Utils.populateTemplateString(htmlTemplates.mediaPictureSourceDefault, [
                        ['{{src}}', viewContent.media.default]
                      ])
                      + htmlTemplates.mediaPictureClosing;
      }

      $media.html(mediaInnerHtml);

      if (M_Utils.getIsTouchDevice()) {
        if (typeof onMediaLoaded === 'function') {
          onMediaLoaded();
        }

        return;
      }

      $media.find('video').off('loadeddata').on('loadeddata', function () {
        if (typeof onMediaLoaded === 'function') {
          onMediaLoaded();
        }
      });
    }

    function resetNav () {
      if ($nav.hasClass('slick-initialized')) {
        $nav.slick('unslick');
      }

      $nav.empty();
    }

    function populateNav (view, wasAlreadyOpen) {
      if (!content.hasOwnProperty(view)) {
        return;
      }

      var contentKeys = Object.keys(content).filter(function (key) {
        return viewVariantsMatch(key, view) && viewIsForCurrentCarView(key, M_Utils.getSelectedView());
      });

      if (contentKeys.length === 0) {
        return;
      }

      // Story variant has a static tab-style thumbnail nav
      if (state.currentVariant === variants.story) {
        resetNav();

        for (var i = 0; i < contentKeys.length; i++) {
          $nav.append(M_Utils.populateTemplateString(htmlTemplates.navItem, [
            ['{{class}}', classes.navItem + (i === contentKeys.indexOf(view) ? ' ' + classes.isActive : '')],
            ['{{view}}', contentKeys[i]],
            ['{{src}}', content[contentKeys[i]].thumbnail]
          ]));
        }

        return;
      }

      // only update nav of feature variant if needed
      if (wasAlreadyOpen && state.previousCarView === M_Utils.getSelectedView() && state.currentVariant === state.prevVariant) {
        return;
      }

      resetNav();
      
      var currentItemIndex = contentKeys.indexOf(view);

      for (var i = 0; i < contentKeys.length; i++) {
        var key = contentKeys[i];

        $nav.append(M_Utils.populateTemplateString(htmlTemplates.navItem, [
          ['{{class}}', classes.navItem + (i === currentItemIndex ? ' ' + classes.isActive : '')],
          ['{{view}}', key],
          ['{{src}}', content[key].thumbnail]
        ]));
      }

      $nav.slick({
        mobileFirst: true,
        slidesToShow: 5,
        centerMode: true,
        centerPadding: 0,
        draggable: false,
        prevArrow: $navPrev[0],
        nextArrow: $navNext[0],
        initialSlide: currentItemIndex,
        rtl: M_Utils.getIsRTL()
      });

      state.previousCarView = M_Utils.getSelectedView();
    }

    function updateContainerClass () {
      $container.removeClass().addClass(classes.containerBase + ' ' + classes.containerBase + '--' + state.currentVariant + ' ' + classes.containerJS);
    }

    function isValidVariant (variant) {
      for (var key in variants) {
        if (variants.hasOwnProperty(key)) {
          if (variants[key] === variant) {
            return true;
          }
        }
      }

      return false;
    }

    function viewVariantsMatch (viewA, viewB) {
      return content[viewA].variant === content[viewB].variant;
    }

    function viewIsForCurrentCarView (view, currentCarView) {
      return content[view].view === currentCarView;
    }

    function onNavItemClick (e) {
      e.preventDefault();
      e.stopPropagation();

      if (state.isNavigating) {
        return;
      }

      var $clickedItem = $(e.currentTarget);

      if (!$clickedItem.is(selectors.navItem)) {
        return;
      }

      var targetView = $clickedItem.attr('data-view');

      if (!targetView) {
        return;
      }

      displayMediaForView(targetView);
      displayView(targetView);

      if (state.currentVariant === variants.feature) {
        var clickedSlideIdx = $clickedItem.closest(selectors.navSlide).data('slick-index');
        $nav.slick('slickGoTo', clickedSlideIdx);
      }
    }

    function onNavControlPrevClick (e) {
      e.preventDefault();
      e.stopPropagation();

      if (state.isNavigating) {
        return;
      }

      displayMediaForView(state.prevView);
      displayView(state.prevView);
      $nav.slick('slickPrev');
    }

    function onNavControlNextClick (e) {
      e.preventDefault();
      e.stopPropagation();

      if (state.isNavigating) {
        return;
      }

      displayMediaForView(state.nextView);
      displayView(state.nextView);
      $nav.slick('slickNext');
    }

    function onCtaLinkClick (e) {
      M_Tracking.trackEvent('click-cta', $(e.currentTarget).attr(attributes.trackingLabel));
    }

    function onCloseButtonClick (e) {
      e.preventDefault();
      e.stopPropagation();
      close();
    }

    function close () {
      state.isOpen = false;

      M_Animation.playSequence('featureFadeOut', function () {
        M_Utils.triggerEvent('nx-close-feature-view');
        M_Animation.resetSequence('featureOpen');
      });
    }

    function showNavControls (show) {
      show ? $navControls.addClass(classes.isVisible) : $navControls.removeClass(classes.isVisible);
    }

    // May not be needed (depends on final decision on displaying landscape rotation prompt on tablets)
    function onOrientationChange () {
      var isPortrait = M_Utils.getIsPortrait();

      if (state.isOpen) {
        if (!state.isPortrait && isPortrait) {
          $media.css({
            height: '75vw',
            right: '0'
          });
        }
      }

      state.isPortrait = isPortrait;
    }


    return {
      init: init,
      displayView: displayView,
      displayMediaForView: displayMediaForView
    }
});

